import { useNavigation } from '@react-navigation/native'
import { useCurrentUserStore } from '@store'
import { GlobalNavigationProp } from '../../../navigation/navigationTypes'

/**
 * Back arrow of the legal pages. Opened by a direct address (typed, reloaded
 * or shared) there is nothing to go back to: lead to the app when logged in,
 * to the login page otherwise.
 */
export const useFooterPageBack = () => {
  const navigation = useNavigation<GlobalNavigationProp>()
  const { userID } = useCurrentUserStore()

  return () => {
    if (navigation.canGoBack()) {
      navigation.goBack()
    } else {
      navigation.reset({ index: 0, routes: [{ name: userID ? 'Tab' : 'Auth' }] })
    }
  }
}
